import React, { useState } from "react";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import ImageGallery from "../ImageGallery/ImageGallery";
// import SwipeableViews from "react-swipeable-views";
// import { autoPlay } from "react-swipeable-views-utils";

// const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const MessageA20 = (props) => {

  function isCaptionAndLinkEmpty(item) {
    let imageArray = props?.item?.text_data?.img
    if(imageArray?.length > 1) return true
    
    let check = imageArray?.every(img => {
      if(img?.caption === "" && img?.link === ""){
        return false
      }
      return true
    }) 
    return check
}
  return (
    <div className="img-wrap">
    
      {/* {renderImages()} */}
     {isCaptionAndLinkEmpty() &&  <ImageGallery data={props?.item?.text_data?.img} showMaximumChat={props?.showMaximumChat}  setIsShowMaximumChat={props?.setIsShowMaximumChat}/>}
    </div>
  );
};

export default MessageA20;
